exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-hldr{padding-top:6.5rem;padding-bottom:0;position:relative}@media (min-width:48em){.video-hldr{padding-top:8.5rem;padding-bottom:0}}@media (min-width:76.8em){.video-hldr{padding-top:15rem;padding-bottom:0}}@media (min-width:99.2em){.video-hldr{padding-top:17.5rem;padding-bottom:0}}.video-hldr video{height:auto;width:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-Video/_index.scss
 ** module id = 204
 ** module chunks = 0
 **/